import gql from 'graphql-tag'

export const StatsUsersGQL = gql`
  query statsUsers {
    merchant {
      stats {
        statsUsers {
          countUsersPrevDate
          totalCountUsers
          userStatistics {
            currDate {
              fio
              phone
            }
            month {
              fio
              phone
            }
            prevDate {
              fio
              phone
            }
          }
        }
      }
    }
  }
`
